import React from "react";
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import ReviewData from './ReviewData';
import PurchasingProcessData from './PurchasingProcessData';
import Medicare from '../../../../Quoters/Medicare/Medicare';

export default function NaviData() {
  const minAge = 0;
  const minAgeDays = 14;
  const maxAge = 17;
  const minCoverageAmount = 10000;
  const maxCoverageAmount = 75000;

  return {
    name: "Navigating Medicare",
    subtitle: "Choosing the path that’s right for you",
    footerMessage: "Get the quality health coverage you need",
    specs: {
      age: { min: minAge, max: maxAge, minAgeDays: minAgeDays },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount }
    },
    basicInfoForm: (history) => {
      return <Medicare landing history={history} />
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    footerButtonName: "REQUEST AN APPOINTMENT",
    showRating: true,
    Review: ReviewData(),
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Navi/NaviData.js